const React = require('react')
const { useEffect, useState } = require('react')
const { useParams, useHistory } = require('react-router-dom')
const { Row, Col, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, UncontrolledTooltip } = require('reactstrap')
const { useFormatBytes } = require('@hooks')
const { useNetworkConfig } = require('@contexts')

require('@styles/pages/address/contract.address.css')

const VerifiedContract = props => {
    const { data } = props
    const { address } = useParams()
    const history = useHistory()
    const { network } = useNetworkConfig()
    const formatBytes = useFormatBytes()

    const [ideOpen, setIdeOpen] = useState(false)
    const [moreOptionsOpen, setMoreOptionsOpen] = useState(false)
    const [chunks, setChunks] = useState([])

    const [displayType, setDisplayType] = useState('Solidity')
    const [displaySourceCode, setDisplaySourceCode] = useState([])

    useEffect(() => {
        if (data && data.information.contract.constructor) {
            const chunks = data.information.contract.constructor.slice(2).match(/.{1,64}/g)
            setChunks(chunks)

            const fileList = Object.entries(JSON.parse(data.information.contract.sourceCode)).map(
                ([fileName, fileData]) => ({
                    name: fileName,
                    content: fileData.content
                })
            )

            setDisplayType(!fileList.length ? 'Solidity' : 'Solidity Multiple files format')
            setDisplaySourceCode(fileList)
        }
    }, [data])

    return (
        <>
            <div
                className='contract-details-wrapper'
                style={{
                    display: 'flex',
                    margin: '32px 0px',
                    flexDirection: 'column',
                    alignItems: 'left'
                }}
            >
                {data.information.contract.similarContract ? (
                    <>
                        <div style={{ marginBottom: '8px' }}>
                            <span className='tx-status-indicator'>
                                <i
                                    className='fas fa-check'
                                    style={{
                                        fontSize: '10px',
                                        backgroundColor: 'var(--warning-color)',
                                        padding: '8px'
                                    }}
                                />
                            </span>
                            &nbsp;Similar Match Source Code&nbsp;
                        </div>
                        <div style={{ fontWeight: 'normal', color: 'var(--grey-color)' }}>
                            <i
                                className='fas fa-info-circle'
                                style={{
                                    fontSize: '12px'
                                }}
                            />
                            &nbsp;This contract matches the&nbsp;
                            <span style={{ fontWeight: 'bold' }}>deployed Bytecode</span>
                            &nbsp;of the Source Code for Contract&nbsp;
                            <span
                                id={`similar-contract`}
                                className={`${network.name}-text-color cursor-pointer`}
                                onClick={() =>
                                    history.push(
                                        `/${network.name}/address/${data.information.contract.similarContract}#code`
                                    )
                                }
                            >
                                {formatBytes(data.information.contract.similarContract, 30, 10, 9)}
                            </span>
                            <UncontrolledTooltip placement='top' target='similar-contract'>
                                {data.information.contract.similarContract}
                            </UncontrolledTooltip>
                        </div>
                        <div style={{ fontWeight: 'normal', color: 'var(--grey-color)' }}>
                            <i
                                className='fas fa-info-circle'
                                style={{
                                    fontSize: '12px'
                                }}
                            />
                            &nbsp;The constructor portion of the code might be different and could alter the actual
                            behaviour of the contract
                        </div>
                    </>
                ) : (
                    <div>
                        <span className='tx-status-indicator'>
                            <i
                                className='fas fa-check'
                                style={{ fontSize: '10px', backgroundColor: 'var(--success-color)', padding: '8px' }}
                            />
                        </span>
                        &nbsp;Contract Source Code Verified&nbsp;
                        <span style={{ fontWeight: 'normal', color: 'var(--grey-color)' }}>(Exact Match)</span>
                    </div>
                )}
            </div>
            <div>
                <Row>
                    <Col md='6'>
                        <Row>
                            <Col md='4'>Contract Name:</Col>
                            <Col md='8'>
                                <span style={{ fontWeight: 'bold' }}>{data?.information.contract.name}</span>
                            </Col>
                        </Row>
                    </Col>
                    <Col md='6'>
                        <Row>
                            <Col md='4'>Optimization Enabled:</Col>
                            <Col md='8'>
                                <span>
                                    <span style={{ fontWeight: 'bold' }}>
                                        {data?.information.contract.optimizationUsed ? 'Yes' : 'No'}
                                    </span>
                                    &nbsp;with&nbsp;
                                    <span style={{ fontWeight: 'bold' }}>
                                        {data?.information.contract.optimizationUsed
                                            ? data?.information.contract.runs
                                            : 0}
                                    </span>
                                    &nbsp;runs
                                </span>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <div className='page-title-border' />
                <Row>
                    <Col md='6'>
                        <Row>
                            <Col md='4'>Compiler Version:</Col>
                            <Col md='8'>
                                <span style={{ fontWeight: 'bold' }}>{data?.information.contract.compilerVersion}</span>
                            </Col>
                        </Row>
                    </Col>
                    <Col md='6'>
                        <Row>
                            <Col md='4'>Other Settings:</Col>
                            <Col md='8'>
                                <span>
                                    <span style={{ fontWeight: 'bold' }}>default</span>
                                    &nbsp;evmVersion
                                </span>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </div>
            <div
                className='contract-details-wrapper'
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                }}
            >
                <div>
                    <i className='far fa-file-code' style={{ fontSize: '14px', color: 'var(--grey-color)' }} />
                    &nbsp;Contract Source Code&nbsp;
                    <span style={{ fontWeight: 'normal', color: 'var(--grey-color)' }}>({displayType})</span>
                </div>
                <div style={{ display: 'flex', gap: '8px' }}>
                    <Dropdown isOpen={ideOpen} toggle={() => setIdeOpen(!ideOpen)} className='dark-dropdown'>
                        <DropdownToggle caret className='form-dropdown-toggle'>
                            IDE
                        </DropdownToggle>
                        <DropdownMenu className='w-100' style={{ padding: '0px' }}>
                            <DropdownItem
                                className={`${network.name}-dropdown-item`}
                                onClick={() => window.open('https://remix.ethereum.org/', '_blank')}
                            >
                                <img
                                    src='https://repository-images.githubusercontent.com/59065830/b62be480-45d2-11ea-9989-803db0f9c44d'
                                    alt='Remix IDE'
                                    style={{ width: '20px' }}
                                />
                                &nbsp;Remix IDE
                            </DropdownItem>
                        </DropdownMenu>
                    </Dropdown>

                    <Dropdown
                        isOpen={moreOptionsOpen}
                        toggle={() => setMoreOptionsOpen(!moreOptionsOpen)}
                        className='dark-dropdown'
                    >
                        <DropdownToggle caret className='form-dropdown-toggle'>
                            More Options
                        </DropdownToggle>
                        <DropdownMenu className='w-100' style={{ padding: '0px' }}>
                            <DropdownItem
                                className={`${network.name}-dropdown-item`}
                                onClick={() => history.push(`/${network.name}/find-similar-contracts?a=${address}`)}
                            >
                                Similar
                            </DropdownItem>
                            <DropdownItem className={`${network.name}-dropdown-item`}>Sol2Uml</DropdownItem>
                            <DropdownItem className={`${network.name}-dropdown-item`}>Submit Audit</DropdownItem>
                            <DropdownItem className={`${network.name}-dropdown-item`}>Compare</DropdownItem>
                        </DropdownMenu>
                    </Dropdown>
                </div>
            </div>
            {displayType === 'Solidity' && <div className='code-block'>{displaySourceCode[0]?.content}</div>}
            {displayType === 'Solidity Multiple files format' && (
                <>
                    {displaySourceCode?.map((item, index) => (
                        <>
                            <div style={{ marginTop: index > 0 ? '12px' : '0px', color: 'var(--grey-color)' }}>
                                File {index + 1} of {displaySourceCode.length}: {item.name}
                            </div>
                            <div className='code-block'>{item.content}</div>
                        </>
                    ))}
                </>
            )}

            <div className='contract-details-wrapper'>
                <i className='fas fa-list-check' style={{ color: 'var(--grey-color)' }} />
                &nbsp;Contract ABI
            </div>
            <div className='code-block'>{JSON.stringify(data?.information.contract.abi)}</div>

            <div className='contract-details-wrapper'>
                <i className='fas fa-code' style={{ color: 'var(--grey-color)' }} />
                &nbsp;Contract Creation Code
            </div>
            <div className='code-block'>{data?.information.contract.creationCode}</div>

            <div className='contract-details-wrapper'>
                <i className='fas fa-code' style={{ color: 'var(--grey-color)' }} />
                &nbsp;Deployed Bytecode
            </div>
            <div className='code-block'>{data?.information.bytecode}</div>

            {data?.information.contract.constructor && (
                <>
                    <div className='contract-details-wrapper'>
                        <i className='fas fa-sitemap' style={{ fontSize: '14px', color: 'var(--grey-color)' }} />
                        &nbsp;Constructor Arguments&nbsp;
                        <span style={{ fontWeight: 'normal', color: 'var(--grey-color)' }}>
                            (ABI-Encoded and is the last bytes of the Contract Creation Code above)
                        </span>
                    </div>
                    <div className='code-block'>
                        {data?.information.contract.constructor}
                        <br />
                        <br />
                        ---------------Decoded View---------------
                        {data?.information.contract.constructorArguments?.map((arg, index) => (
                            <div>
                                Arg [{index}]: {arg.name} ({arg.type}):{arg.value}
                            </div>
                        ))}
                        <br />
                        <br />
                        ---------------Encoded View---------------
                        <div>{chunks?.length} Constructor Arguments found :</div>
                        {chunks?.map((chunk, index) => (
                            <div>
                                Arg [{index}]: {chunk}
                            </div>
                        ))}
                    </div>
                </>
            )}
        </>
    )
}

module.exports = { VerifiedContract }
